import { useLocation } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { useModalStore } from '../stores/modal';

const FLOW_QUERY_KEYS = ['editReportId', 'sig', 'approval', 'openContacts'];

export function useFabSuppression(): boolean {
  const location = useLocation();
  const anyModalOpen = useModalStore(
    useShallow(
      (s) =>
        s.createOrganization ||
        s.createSite ||
        s.createInspection ||
        s.createReport ||
        s.createTbm ||
        s.editSite !== null ||
        s.resolutionPhoto !== null ||
        s.actionResult !== null ||
        s.cameraCapture
    )
  );

  const params = new URLSearchParams(location.search);
  const hasFlowParam = FLOW_QUERY_KEYS.some((key) => params.has(key));

  return Boolean(anyModalOpen) || hasFlowParam;
}
